module App {
    export class Variables {
        static websiteId: number
        static currentPageId: number
        static license: string
        static configuratorType: string
        static thankyoutxt: string
        static noDesiredProducText: string
        static websiteColor: string
        static brandName: string
        static privacyStatement: string
        static websiteUrl: string
        static allowColorChange: boolean
        static firstName: string
        static middleName: string
        static lastName: string
        static phone: string
        static discountCode: string
        static mileage: string
        static gender: string
        static email: string
        static telephone: string
        static workcode: string
        static title: string
        static recurringCustomer: boolean
        static mileageNotRequired: boolean
        static carBrands: string[]
        static fuelTypes: string[]
        static allowLogin: boolean
        static hideActionCode: boolean
        static isRdwAvailable: boolean
        static rdwUnavailableText: string
        static utmParams: App.Interfaces.IUtmParam[]
        static currentSettelmentReplacementVehicleText: App.Interfaces.IReplacementVehicleText[]
        static globalReplacementVehicleText: App.Interfaces.IReplacementVehicleText[]
        static BringEarlyOptionDayBeforeText: string
        static BringEarlyOptionEarlyText: string
        static BringEarlyOptionEveningText: string
        static BringEarlyOptionNoText: string
    }
}